import React, { useEffect, useState } from "react";
import CustomDatePicker from "../../../../components/Custom-Datepicker";
import Select from "react-select";
import { Table } from "react-bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_URL } from "../../../../constants";
import {
  GetServiceCaller,
  PostServiceCaller,
  DeleteServiceCaller,
} from "../../../../services/serviceCaller";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import "react-international-phone/style.css";
import { FaSpinner } from "react-icons/fa";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import moment from "moment/moment";
import DeleteModal from '../../../../components/DeletePopUpComponent'
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";

const customStyle = {
  control: (provided, state) => ({
    ...provided,
    height: "64px",
    overflow: "scroll",
  }),
  multiValueRemove: (base, state) => ({
    ...base,
    color: "white",
    ":hover": {
      backgroundColor: "red",
      color: "white",
    },
  }),
};

const CreatePartnerMasterEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();


  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Edit Partner Master"))
  }, [])
  const initialFormData = {
    Name: "",
    Address: "",
    Zip_code: "",
    Contact: "",
    Email: "",
    Gst_vat: "",
    Vsa_Start_Date: "",
    Vsa_End_Date: "",
    CandidateReferralType_174: "",
    ReferralID: "",
    CountryID: "",
    StateID: "",
    CityID: "",
    Primary_Skills: "",
    Technology_Partner: "",
    ROMID: "",
    lines: [
      {
        LineNo: 1,
        RefName: "",
        RefDesignation: "",
        RefDepartment: "",
        RefContact: "",
        RefEmail: "",
        RefRemarks: "",
        vendorID: "",
        ID: "",
      },
    ],
  };

  const [loading, setLoading] = useState(true);
  const [skillOption, setSkillOption] = useState([]);
  const [romPocOption, setRomPocOption] = useState([]);
  const [refTypeOption, setRefTypeOption] = useState([]);
  const [jobPortalOption, setJobPortalOption] = useState([]);
  const [referenceOption, setReferenceOption] = useState([]);
  const [countryOption, setCountryOption] = useState([]);
  const [formData1, setFormData1] = useState(initialFormData);


  useEffect(() => {
    fetchRomVendor();

    if (id) {
      fetchRomVendorID(id);
    }
  }, [id]);

  const fetchRomVendor = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}Rom-vendor`);
      if (response.status === 200) {
        const cleanedData = response?.data?.data;

        const romOptions = cleanedData?.rompoc?.map((record) => ({
          value: record.value,
          label: record.text,
        }));
        setRomPocOption(romOptions.sort((a, b) => a.label.localeCompare(b.label)));

        const refTypeOptions = cleanedData?.CandidateReferralType_list?.map(
          (record) => ({
            value: record.value,
            label: record.text,
          })
        );
        setRefTypeOption(refTypeOptions.sort((a, b) => a.label.localeCompare(b.label)));

        const jobportalOptions = cleanedData?.source?.map((record) => ({
          value: record.VALUE,
          label: record.TEXT,
        }));
        setJobPortalOption(jobportalOptions.sort((a, b) => a.label.localeCompare(b.label)));

        setRomPocOption(romOptions.sort((a, b) => a.label.localeCompare(b.label)));

        const refOptions = cleanedData?.reference?.map((record) => ({
          value: record.VALUE,
          label: record.TEXT,
        }));
        setReferenceOption(refOptions.sort((a, b) => a.label.localeCompare(b.label)));
        const countryOpt = cleanedData?.country?.map((record) => ({
          value: record.value,
          label: record.text,
        }));
        setCountryOption(countryOpt.sort((a, b) => a.label.localeCompare(b.label)));
        const cityOptionss = cleanedData?.city?.map((record) => ({
          value: record.value,
          label: record.text,
        }));
        setCityOption(cityOptionss.sort((a, b) => a.label.localeCompare(b.label)));
        const stateOptionss = cleanedData?.state?.map((record) => ({
          value: record.value,
          label: record.text,
        }));
        setStateOption(stateOptionss.sort((a, b) => a.label.localeCompare(b.label)));
        const skillOptions = cleanedData?.skills?.map((record) => ({
          value: record.ID,
          label: record.Name,
        }));
        setSkillOption(skillOptions.sort((a, b) => a.label.localeCompare(b.label)));
        setLoading(false);
      } else {
        console.error(
          "Failed to fetch partnerMaster. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching PartnerMaster:", error);
    }
  };

  {
    /* Primary Skill Edit Select code */
  }
  const [primarySkillSplit, setPrimarySkillSplit] = useState([]);
  const [primarySkillNewValue, setPrimarySkillNewValue] = useState([]);
  const [technologySplit, setTechnologySplit] = useState([]);
  const [technologyNewValue, setTechnologyNewValue] = useState([]);

  useEffect(() => {
    const mappedSkills = primarySkillSplit?.map((element) =>
      skillOption.find((o) => o.value == Number(element))
    );
    const mappedTechSkills = technologySplit?.map((element) =>
      skillOption.find((o) => o.value == Number(element))
    );
    setTechnologyNewValue(mappedTechSkills);
    setPrimarySkillNewValue(mappedSkills);
    setFormData1({
      ...formData1,
      Primary_Skills: mappedSkills,
      Technology_Partner: mappedTechSkills,
    });
  }, [primarySkillSplit, skillOption, technologySplit, skillOption]);

  const fetchRomVendorID = async (id) => {
    try {
      const response = await GetServiceCaller(`${API_URL}Rom-vendor/${id}`);
      if (response.status === 200) {
        const cleanedData = response?.data?.data;

        // set selected Primrayskills

        const tempskill_array =
          cleanedData?.romvendor?.Primary_Skills?.split(",");
        setPrimarySkillSplit(tempskill_array);

        const temptechnology_array =
          cleanedData?.romvendor?.Technology_Partner?.split(",");
        setTechnologySplit(temptechnology_array);

        const fromEdit = {
          Name: cleanedData.romvendor.Name,
          Address: cleanedData.romvendor.Address,
          Zip_code: cleanedData.romvendor.Zip_code,
          Contact: cleanedData.romvendor.Contact,
          Email: cleanedData.romvendor.Email,
          Gst_vat: cleanedData.romvendor.Gst_vat,
          Vsa_Start_Date:
            cleanedData.romvendor.Vsa_Start_Date !== null &&
              cleanedData.romvendor.Vsa_Start_Date !== undefined
              ? moment(cleanedData.romvendor.Vsa_Start_Date).format(
                "DD-MMM-YYYY"
              )
              : "",
          Vsa_End_Date:
            cleanedData.romvendor.Vsa_End_Date !== null &&
              cleanedData.romvendor.Vsa_End_Date !== undefined
              ? moment(cleanedData.romvendor.Vsa_End_Date).format("DD-MMM-YYYY")
              : "",
          ROMID: cleanedData.romvendor.ROMID,
          CandidateReferralType_174:
            cleanedData.romvendor.CandidateReferralType_174,
          ReferralID: cleanedData.romvendor.ReferralID,
          CountryID: cleanedData.romvendor.CountryID,
          StateID: cleanedData.romvendor.StateID,
          CityID: cleanedData.romvendor.CityID,
          Primary_Skills: primarySkillNewValue,
          Technology_Partner: technologyNewValue,
          lines: cleanedData.romvendorpoc.map((ele, index) => ({
            LineNo: ele.LineNo,
            RefName: ele.RefName,
            RefDesignation: ele.RefDesignation,
            RefDepartment: ele.RefDepartment,
            RefContact: ele.RefContact,
            RefEmail: ele.RefEmail,
            RefRemarks: ele.RefRemarks,
            vendorID: ele?.vendorID,
            ID: ele?.ID,
          })),
        };

        setFormData1(fromEdit);

        const romOptions = cleanedData.rompoc.map((record) => ({
          value: record.value,
          label: record.text,
        }));
        setRomPocOption(romOptions.sort((a, b) => a.label.localeCompare(b.label)));
        const countryOpt = cleanedData.country.map((record) => ({
          value: record.value,
          label: record.text,
        }));
        setCountryOption(countryOpt.sort((a, b) => a.label.localeCompare(b.label)));
        const refTypeOptions = cleanedData.CandidateReferralType_list.map(
          (record) => ({
            value: record.value,
            label: record.text,
          })
        );
        setRefTypeOption(refTypeOptions.sort((a, b) => a.label.localeCompare(b.label)));

        const jobportalOptions = cleanedData.source.map((record) => ({
          value: record.VALUE,
          label: record.TEXT,
        }));

        setJobPortalOption(jobportalOptions.sort((a, b) => a.label.localeCompare(b.label)));

        setRomPocOption(romOptions.sort((a, b) => a.label.localeCompare(b.label)));

        const refOptions = cleanedData.reference.map((record) => ({
          value: record.value,
          label: record.text,
        }));
        setReferenceOption(refOptions.sort((a, b) => a.label.localeCompare(b.label)));

        const cityOptionss = cleanedData?.city?.map((record) => ({
          value: record.value,
          label: record.text,
        }));
        setCityOption(cityOptionss.sort((a, b) => a.label.localeCompare(b.label)));
        const stateOptionss = cleanedData?.state?.map((record) => ({
          value: record.value,
          label: record.text,
        }));
        setStateOption(stateOptionss.sort((a, b) => a.label.localeCompare(b.label)));
        setLoading(false);
      } else {
        console.error(
          "Failed to fetch partnerMaster. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching PartnerMaster:", error);
    }
  };
  const handleChange = (e, index) => {
    const { name, type, checked, value } = e.target;
    const updatedLines = [...formData1.lines]; // Create a copy of the lines array
    const newValue = type === "checkbox" ? checked : value;

    let isValid = true; // Assume valid initially
    let errorMessage = ""; // To hold error messages

    // Validation for RefName
    if (name === "RefName") {
      if (!/^[a-zA-Z\s]*$/.test(value)) {
        isValid = false;
        errorMessage = "Only alphabetic characters are allowed.";
      }
    }

    // // Validation for RefEmail
    // if (name === "RefEmail") {
    //   const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    //   if (!emailPattern.test(value)) {
    //     isValid = false;
    //     errorMessage = "Invalid email format.";
    //   }
    // }

    // Validation for RefContact
    // if (name === "RefContact") {
    //   if (!/^\d{10}$/.test(value)) {
    //     isValid = false;
    //     errorMessage = "Contact number must be exactly 10 digits.";
    //   }
    // }

    // Update the lines array and form data based on validity
    if (isValid) {
      updatedLines[index][name] = newValue; // Update the line value
      setFormData1((prevState) => ({
        ...prevState,
        lines: updatedLines,
      }));
      // Clear specific error message
      setErrors((prevErrors) => ({
        ...prevErrors,
        [index]: { ...prevErrors[index], [name]: "" },
      }));
    } else {
      // Set error message if invalid
      setErrors((prevErrors) => ({
        ...prevErrors,
        [index]: { ...prevErrors[index], [name]: errorMessage },
      }));
    }
  };

  const handleAddLine = () => {
    // Get the last row in the lines array
    const currentRow = formData1.lines.length !== 0 ? formData1.lines[formData1.lines.length - 1] : null;

    // Check if the current row is empty and show a toast if needed
    if (currentRow && !currentRow.RefName) {
      toast.error("Please fill in the current row.", {
        position: "top-right",
      });
      return;
    }

    // Find the smallest missing line number
    let newLineNo = 1; // Start from 1
    const existingLineNos = formData1.lines.map((row) => row.LineNo);

    // Check if there's any missing number in the sequence
    while (existingLineNos.includes(newLineNo)) {
      newLineNo++; // Increment until we find the first missing line number
    }

    // Log the new line number for debugging

    // Add a new line with the correct line number
    setFormData1((prevState) => ({
      ...prevState,
      lines: [
        ...prevState.lines,
        {
          LineNo: newLineNo,
          RefName: "",
          RefDesignation: "",
          RefDepartment: "",
          RefContact: "",
          RefEmail: "",
          RefRemarks: "",
          vendorID: "",
          ID: "",
        },
      ],
    }));
  };




  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if any line's refname is blank
    // const hasEmptyRefName = formData1?.lines?.some((line) => !line.RefName);

    // if (hasEmptyRefName) {
    //   toast.error("Please fill in all the required fields in the POC section.");
    //   return; // Stop submission
    // }

    if (validateForm()) {
      setLoading(true);
      try {
        let response;
        if (id) {
          response = await PostServiceCaller(
            `${API_URL}Rom-vendor/${id}`,
            {
              Name: formData1.Name,
              Address: formData1.Address,
              Zip_code: formData1.Zip_code,
              Contact: formData1.Contact,
              Email: formData1.Email,
              Gst_vat: formData1.Gst_vat,
              Vsa_Start_Date: formData1.Vsa_Start_Date,
              Vsa_End_Date: formData1.Vsa_End_Date,
              CandidateReferralType_174: formData1.CandidateReferralType_174,
              ReferralID: formData1.ReferralID || 0,
              CityID: formData1.CityID,
              CountryID: formData1.CountryID,
              Primary_Skills: formData1.Primary_Skills,
              Technology_Partner: formData1.Technology_Partner,
              StateID: formData1.StateID,
              ROMID: formData1.ROMID,
              lines: formData1?.lines,
            },
            "put"
          );
        }


        if (response.status === 200) {
          toast.success("Data submitted successfully");
          setFormData1(initialFormData);
          setTimeout(() => {
            window.location.href = "/partner-master";
          }, 2000);
        } else {
          console.error(
            "Failed to submit data. Server responded with status:",
            response.status
          );
          console.error("Response data:", response.data);
        }
      } catch (error) {
        console.error("Error while submitting data:", error);
        if (
          error.response &&
          error.response.data &&
          error.response.data.error
        ) {
          toast.error(error.response.data.error, {
            position: "top-right",
          });
          console.error("Server responded with status:", error.response.status);
          console.error("Response data:", error.response.data);
        }
      } finally {
        setLoading(false);
      }
    } else {
      // If there are validation errors, display them
      if (errors && Object.keys(errors).length > 0) {
        Object.values(errors).forEach((errorMessage) => {
          if (errorMessage) {
            toast.error(errorMessage, { position: "top-right" });
          }
        });
      }

    }

    // Step 2: Check if any line's RefName is empty
    const hasEmptyRefName = formData1?.lines?.some((line) => !line.RefName);
    if (hasEmptyRefName) {
      toast.error("Please fill in all the required fields in the POC section.");
      return; // Stop submission if any RefName is empty
    }

  };

  const [refValue, setRefValue] = useState();

  const handleReference = (selectedReference) => {
    setFormData1({
      ...formData1,
      ReferralID: selectedReference.value,
    });
    setRefValue(selectedReference.value);
  };

  useEffect(() => {
    fetchState(formData1.CountryID);
  }, [formData1.CountryID]);

  useEffect(() => {
    fetchCity(formData1.StateID);
  }, [formData1.StateID]);

  const [stateOption, setStateOption] = useState([]);
  const [cityOption, setCityOption] = useState([]);

  const fetchState = async (id) => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}fetch-state-city/${id}`
      );
      if (response.status === 200) {
        const cleanedData = response.data.StateCity;
        const Opt = cleanedData?.map((record) => ({
          value: record.value,
          label: record.text,
        }));

        setStateOption(Opt);

        setLoading(false);
      } else {
        console.error(
          "Failed to fetch Area Master. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Area Master:", error);
    }
  };
  const fetchCity = async (id) => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}fetch-state-city/${id}`
      );
      if (response.status === 200) {
        const cleanedData = response.data.StateCity;
        const Opt = cleanedData?.map((record) => ({
          value: record.value,
          label: record.text,
        }));

        setCityOption(Opt);

        setLoading(false);
      } else {
        console.error(
          "Failed to fetch Area Master. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Area Master:", error);
    }
  };

  const [errors, setErrors] = useState({});
  const validateForm = () => {
    const newErrors = {};

    // Required field validations
    if (!formData1.Name) newErrors.Name = "Name is required";
    if (!formData1.Address) newErrors.Address = "Address is required";
    if (!formData1.Zip_code) newErrors.Zip_code = "Zip code is required";
    if (!formData1.Email) newErrors.Email = "Email is required";
    if (!formData1.Contact) newErrors.Contact = "Contact No is required";
    if (!formData1.CountryID) newErrors.CountryID = "Country is required";
    if (!formData1.StateID) newErrors.StateID = "State is required";
    if (!formData1.CityID) newErrors.CityID = "City is required";

    // Adding validation for Primary Skills and Technology Partner
    if (!formData1.Primary_Skills)
      newErrors.Primary_Skills = "Primary Skill is required";
    if (!formData1.Technology_Partner)
      newErrors.Technology_Partner = "Technology Partner is required";

    // Validate line-level data
    formData1.lines.forEach((line, index) => {
      if (!line.RefName) {
        if (!newErrors[index]) newErrors[index] = {};
        newErrors[index].RefName = "POC Name is required.";
      }
      if (!line.RefContact) {
        if (!newErrors[index]) newErrors[index] = {};
        newErrors[index].RefContact = "Contact No is required.";
      } else if (!/^\d{0,10}$/.test(line.RefContact)) {
        if (!newErrors[index]) newErrors[index] = {};
        newErrors[index].RefContact = "Contact must be up to 10 digits.";
      }
      if (!line.RefEmail) {
        if (!newErrors[index]) newErrors[index] = {};
        newErrors[index].RefEmail = "Email is required.";
      } else {
        // Email regex validation
        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailPattern.test(line.RefEmail)) {
          if (!newErrors[index]) newErrors[index] = {};
          newErrors[index].RefEmail = "Please enter a valid email address.";
        }
      }
    });

    setErrors(newErrors);

    // Return true if there are no errors
    return Object.keys(newErrors).length === 0;
  };

  const handleSelect = (e, name) => {
    const value = e.value;

    setFormData1({
      ...formData1,
      [name]: value, // Update formData with the selected value
    });

    // Fetch states or cities based on the selected country or state
    if (name === "CountryID") {
      setFormData1((prevState) => ({
        ...prevState,
        StateID: null, // Update formData with the selected value
        CityID: null, // Update formData with the selected value
      }));
      fetchState(value);
    } else if (name === "StateID") {
      setFormData1((prevState) => ({
        ...prevState,

        CityID: null, // Update formData with the selected value
      }));
      fetchCity(value);
    }

    // Validate fields including Primary_Skills and Technology_Partner
    const fieldsToValidate = [
      "CountryID",
      "StateID",
      "CityID",
      "Primary_Skills",
      "Technology_Partner",
    ];

    if (fieldsToValidate.includes(name)) {
      let isValid = true;

      if (!value) {
        isValid = false; // Invalid if no value is selected
      }

      setErrors((errors) => ({
        ...errors,
        [name]: isValid ? "" : "This field is required.", // Set or clear the error message
      }));
    }
  };

  const handleHeadChange = (e) => {
    const { name, value } = e.target;
    let isValid = true;

    // Validation rules
    if (name === "Contact") {
      // Contact: Apply only required validation
      isValid = value.trim() !== ""; // Ensure the value is not empty
    } else if (name === "Name") {
      isValid = /^[a-zA-Z\s]*$/.test(value); // Name: Allow only alphabetic characters
    } else if (name === "PinCode" || name === "Zip_code") {
      isValid = value.trim() !== ""; // Ensure it's not empty
    } else if (name === "Email") {
      isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value); // Email: Basic email format validation
    }

    if (isValid) {
      // Update form data and clear errors if valid input
      setFormData1((prevState) => ({
        ...prevState,
        [name]: value,
      }));
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "", // Clear the error message for valid input
      }));
    } else {
      // Set errors if validation fails
      setFormData1((prevState) => ({
        ...prevState,
        [name]: value,
      }));
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]:
          name === "Name"
            ? "Only alphabetic characters are allowed."
            : name === "Zip_code" || name === "PinCode"
              ? "Zip code is required."
              : name === "Email"
                ? "Please enter a valid email address."
                : "This field is required.",
      }));
    }

    // Additional check for Contact to ensure it's not empty
    if (name === "Contact" && value.trim() === "") {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "Contact No is required", // Display the required message
      }));
    } else if (name === "Contact" && value.trim() !== "") {
      // Clear error message when the value is filled
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "", // Clear the error message for valid input
      }));
    }
  };
  // const handleHeadChange = (e) => {
  //   const { name, value } = e.target;
  //   let isValid = true;

  //   // Validation rules
  //   if (name === "Contact") {
  //     // Mobile number validation: Allow up to 10 digits
  //     isValid = /^\d{0,10}$/.test(value);
  //   }

  //   if (isValid) {
  //     // Update the form data and clear errors if input is valid
  //     setFormData1((prevState) => ({
  //       ...prevState,
  //       [name]: value,
  //     }));
  //     setErrors((prevState) => ({
  //       ...prevState,
  //       [name]: "", // Clear the error message for valid input
  //     }));
  //   } else {
  //     // Set form data and errors if validation fails
  //     setFormData1((prevState) => ({
  //       ...prevState,
  //       [name]: value,
  //     }));
  //     setErrors((prevState) => ({
  //       ...prevState,
  //       [name]: "Mobile number must be up to 10 digits.", // Custom message
  //     }));
  //   }

  //   // Additional check for MobileNo1 to ensure it's exactly 10 digits
  //   if (name === "Contact" && value.length > 0 && value.length < 10) {
  //     setErrors((prevState) => ({
  //       ...prevState,
  //       [name]: "Mobile number must be exactly 10 digits.",
  //     }));
  //   }
  // };
  const handleDate = (e) => {

    const { name, value } = e?.target;

    setFormData1({
      ...formData1,
      [name]: value,
    });
  };

  const handleMultiSelect = (selectedOption, fieldName) => {
    // Update form state
    setFormData1((prevState) => ({
      ...prevState,
      [fieldName]: selectedOption || [],
    }));

    // Perform validation on selection
    if (selectedOption.length === 0) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [fieldName]: `${fieldName.replace("_", " ")} is required.`,
      }));
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [fieldName]: "",
      }));
    }
  };




  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);


  const openDeleteModal = (item) => {

    setShowDeleteModal(true);
    setSelectedDeleteItem(item);

  };


  const handleModalDelete = () => {
    if (selectedDeleteItem) {

      handleDeletePOCLine(selectedDeleteItem.index, selectedDeleteItem.vendorID, selectedDeleteItem.LineNo);

      setShowDeleteModal(false);
      setSelectedDeleteItem(null);

    }
  };
  const handleDeletePOCLine = async (index, vendorID, LineNo) => {
    try {

      await DeleteServiceCaller(
        `${API_URL}rom-vendor-details-delete/${vendorID}/${LineNo}`,
        {},
        "delete"
      );
      const updatedLines = formData1.lines.filter((_, i) => i !== index);
      setFormData1({ ...formData1, lines: updatedLines });
    } catch (error) {
      console.error("There was an error deleting the line!", error);
    }
  };
  const handleDeleteClose = () => {
    setShowDeleteModal(false);
    setSelectedDeleteItem(null);

  };
  return (
    <>
      <div className="Container">
        <form
          className="rounded mt-2 bg-white"
          onSubmit={handleSubmit}
          id="formOne"
        >
          {/** Input field Code Start */}

          <ul className="nav nav-tabs" id="myTab" role="tablist">
            <li className="nav-item" role="presentation">
              <button
                className="nav-link active"
                id="contractorDetails-tab"
                data-bs-toggle="tab"
                data-bs-target="#contractorDetails"
                type="button"
                role="tab"
                aria-controls="contractorDetails"
                aria-selected="true"
              >
                Partner Details<span className="">{formData1.Name?.trim() && ` : ${formData1.Name}`}</span>
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className="nav-link"
                id="addProject-tab"
                data-bs-toggle="tab"
                data-bs-target="#addProject"
                type="button"
                role="tab"
                aria-controls="addProject"
                aria-selected="false"
              >
                POC Details
              </button>
            </li>
          </ul>
          <div className="tab-content" id="myTabContent">
            <div
              className="tab-pane fade show active"
              id="contractorDetails"
              role="tabpanel"
              aria-labelledby="contractorDetails-tab"
            >
              <div className="p-2">
                <div class="card-body  mx-2">
                  <div className="row ">
                    <div className="col-md-3">
                      <label class="form-label">
                        Name<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control ${errors.Name ? "is-invalid" : ""
                          }`}
                        name="Name"
                        // onChange={handleName}
                        onChange={(e) => handleHeadChange(e)}
                        placeholder="Name"
                        value={formData1.Name}
                      />
                      {errors.Name && (
                        <div className="invalid-feedback">
                          {errors.Name}
                        </div>
                      )}
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">Contact No.<span className="text-danger">*</span></label>
                      <input
                        type="number"
                        name="Contact"
                        placeholder="Contact No."
                        className={`form-control ${errors.Contact ? "is-invalid" : ""}`}
                        // rules={{ required: true }}
                        value={formData1.Contact || ""}
                        onChange={(e) => handleHeadChange(e)}

                      />
                      {errors.Contact && (
                        <div className="invalid-feedback">
                          {errors.Contact}
                        </div>
                      )}
                    </div>

                    <div className="col-md-3">
                      <label class="form-label">
                        Email ID<span className="text-danger">*</span>
                      </label>
                      <input
                        type="email"
                        className={`form-control ${errors.Email ? "is-invalid" : ""
                          }`}
                        name="Email"
                        placeholder="Email"
                        // onChange={handleEmail}
                        onChange={(e) => handleHeadChange(e)}
                        value={formData1.Email}
                      />
                      {errors.Email && (
                        <div className="invalid-feedback">
                          {errors.Email}
                        </div>
                      )}
                    </div>
                    <div className="col-md-3">
                      <label class="form-label">
                        Address<span className="text-danger">*</span>
                      </label>

                      {/* <input type="text" className="form-control" /> */}
                      <textarea
                        rows="1"
                        placeholder="Address"
                        className={`form-control ${errors.Address ? "is-invalid" : ""
                          }`}
                        name="Address"
                        // onChange={handleAddress}
                        onChange={(e) => handleHeadChange(e)}
                        value={formData1.Address}
                      ></textarea>
                      {errors.Address && (
                        <div className="invalid-feedback">
                          {errors.Address}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="col-md-3">
                      <label class="form-label">
                        Country<span className="text-danger">*</span>
                      </label>
                      <Select
                        name="CountryID"
                        // onChange={handleCountry}
                        onChange={(e, action) =>
                          handleSelect(e, action.name)
                        }
                        value={countryOption.find(
                          (o) => o.value == formData1.CountryID
                        )}
                        class="form-control"
                        className={` ${errors.CountryID ? "is-invalid" : ""
                          }`}
                        options={countryOption}
                      />
                      {errors.CountryID && (
                        <div className="invalid-feedback">
                          {errors.CountryID}
                        </div>
                      )}
                    </div>
                    <div className="col-md-3">
                      <label class="form-label">
                        State<span className="text-danger">*</span>
                      </label>
                      <Select
                        name="StateID"
                        // onChange={handleState}
                        onChange={(e, action) =>
                          handleSelect(e, action.name)
                        }
                        value={
                          formData1.StateID == null
                            ? ""
                            : stateOption.find(
                              (o) => o.value == formData1.StateID
                            )
                        }
                        class="form-control"
                        className={` ${errors.StateID ? "is-invalid" : ""}`}
                        options={stateOption}
                      />
                      {errors.StateID && (
                        <div className="invalid-feedback">
                          {errors.StateID}
                        </div>
                      )}
                    </div>
                    <div className="col-md-3">
                      <label class="form-label">
                        City<span className="text-danger">*</span>
                      </label>

                      <Select
                        name="CityID"
                        // onChange={handleCity}
                        onChange={(e, action) =>
                          handleSelect(e, action.name)
                        }
                        value={
                          formData1.CityID == null
                            ? ""
                            : cityOption.find(
                              (o) => o.value == formData1.CityID
                            )
                        }
                        class="form-control"
                        className={` ${errors.CityID ? "is-invalid" : ""}`}
                        options={cityOption}
                      />
                      {errors.CityID && (
                        <div className="invalid-feedback">
                          {errors.CityID}
                        </div>
                      )}
                    </div>
                    <div className="col-md-3">
                      <label class="form-label">
                        Zip Code<span className="text-danger">*</span>
                      </label>
                      <input
                        type="number"
                        className={`form-control ${errors.Zip_code ? "is-invalid" : ""
                          }`}
                        name="Zip_code"
                        placeholder="Zip Code"
                        // onChange={(e) => handleZipCode(e)}
                        onChange={(e) => handleHeadChange(e)}
                        value={formData1.Zip_code}
                      />{" "}
                      {errors.Zip_code && (
                        <div className="invalid-feedback">
                          {errors.Zip_code}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="col-md-3">
                      <label class="form-label">GST/VAT #</label>

                      <input
                        type="text"
                        className="form-control"
                        name="Gst_vat"
                        placeholder="GST/VAT #"
                        // onChange={handleGstVat}
                        onChange={(e) => handleHeadChange(e)}
                        value={formData1.Gst_vat}
                      />
                    </div>
                    <div className="col-md-3">
                      <label className="form-label" htmlFor="VsaStartDate">
                        VSA Start Date
                      </label>
                      <CustomDatePicker
                        // handleChange={handleVsaStartDate}
                        handleChange={(e) => handleDate(e)}
                        value={formData1.Vsa_Start_Date}
                        name="Vsa_Start_Date"
                        id="VsaStartDate"
                        className="form-control"
                        placeholderText="DD-MMM-YYYY"
                      // minDate={formData1.Vsa_Start_Date} // Uncomment to prevent StartDate from being after EndDate
                      />
                    </div>
                    <div className="col-md-3">
                      <label className="form-label" htmlFor="VsaEndDate">
                        VSA End Date
                      </label>
                      <CustomDatePicker
                        // handleChange={handleVsaEndDate}
                        handleChange={(e) => handleDate(e)}
                        value={formData1.Vsa_End_Date}
                        name="Vsa_End_Date"
                        id="VsaEndDate"
                        className="form-control"
                        placeholderText="DD-MMM-YYYY"
                        minDate={new Date(formData1.Vsa_Start_Date)} // Prevent EndDate from being before StartDate
                      />
                    </div>

                    <div className="col-md-3">
                      <label class="form-label">RMG POC</label>
                      <Select
                        name="ROMID"
                        // onChange={(rompoc) => {
                        //     setRomPoC(rompoc);
                        //     setFormData1({
                        //         ...formData1,
                        //         ROMID: rompoc.value,
                        //     });
                        // }}
                        onChange={(e, action) =>
                          handleSelect(e, action.name)
                        }
                        value={romPocOption.find(
                          (option) => option.value == formData1.ROMID
                        )}
                        class="form-control"
                        options={romPocOption}
                      />
                    </div>
                  </div>

                  <div className="row mt-2">
                    <div className="col-md-3">
                      <label class="form-label">
                        Technology Partner{" "}<span className="text-danger">*</span>
                      </label>
                      <Select
                        name="Technology_Partner"
                        // menuShouldScrollIntoView={true}
                        isMulti
                        classNamePrefix="select"
                        styles={customStyle}
                        // onChange={(selectedOption) => setFormData1({ ...formData1, Technology_Partner: [...selectedOption] })}
                        // onChange={(e, action) =>
                        //   handleSelect(e, action.name)
                        // }
                        onChange={(selectedOption) =>
                          handleMultiSelect(
                            selectedOption,
                            "Technology_Partner"
                          )
                        }
                        value={formData1.Technology_Partner}
                        className={`basic-multi-select ${errors.Technology_Partner ? "is-invalid" : ""
                          }`}
                        options={skillOption}
                      />
                      {errors.Technology_Partner && (
                        <div className="invalid-feedback">
                          {errors.Technology_Partner}
                        </div>
                      )}
                    </div>
                    <div className="col-md-3">
                      <label class="form-label">
                        Primary Skill<span className="text-danger">*</span>
                      </label>
                      <Select
                        // menuShouldScrollIntoView={true}
                        isMulti
                        styles={customStyle}
                        classNamePrefix="select"
                        name="Primary_Skills"
                        // onChange={(selectedOption) => setFormData1({ ...formData1, Primary_Skills: [...selectedOption] })}
                        // onChange={(e, action) =>
                        //   handleSelect(e, action.name)
                        // }
                        onChange={(selectedOption) =>
                          handleMultiSelect(
                            selectedOption,
                            "Primary_Skills"
                          )
                        }
                        value={formData1.Primary_Skills}
                        className={`basic-multi-select ${errors.Primary_Skills ? "is-invalid" : ""
                          }`}
                        options={skillOption}
                      />{" "}
                      {errors.Primary_Skills && (
                        <div className="invalid-feedback">
                          {errors.Primary_Skills}
                        </div>
                      )}
                    </div>
                    <div className="col-md-3">
                      <label class="form-label">Source</label>
                      <Select
                        // value={}

                        name="CandidateReferralType_174"
                        // onChange={(refType) => handleSource(refType)}
                        onChange={(e, action) =>
                          handleSelect(e, action.name)
                        }
                        value={refTypeOption.find(
                          (option) =>
                            option.value ===
                            formData1.CandidateReferralType_174
                        )}
                        class="form-control"
                        options={[
                          { value: "", label: "Select" },
                          ...refTypeOption,
                        ]}
                      />
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">
                        {formData1.CandidateReferralType_174 != 6759
                          ? refTypeOption.find(
                            (option) =>
                              option.value ===
                              formData1.CandidateReferralType_174
                          )?.label
                          : null}
                      </label>
                      {formData1.CandidateReferralType_174 === 2034 ? (
                        <Select
                          name="ReferralID"
                          // onChange={(jobPortal) =>
                          //     handleJobPortal(jobPortal)
                          // }
                          onChange={(e, action) =>
                            handleSelect(e, action.name)
                          }
                          value={jobPortalOption.find(
                            (option) =>
                              option.value === formData1.ReferralID
                          )}
                          options={[
                            { value: "", label: "Select" },
                            ...jobPortalOption,
                          ]}
                        />
                      ) : (
                        formData1.CandidateReferralType_174 === 2035 && (
                          <Select
                            name="ReferralID"
                            onChange={(reference) =>
                              handleReference(reference)
                            }
                            value={referenceOption.find(
                              (option) =>
                                option.value === formData1.ReferralID
                            )}
                            options={[
                              { value: "", label: "Select" },
                              ...referenceOption,
                            ]}
                          />
                        )
                      )}
                    </div>
                  </div>

                  {/* <div className="row mt-1"></div> */}
                </div>
              </div>
            </div>
            {/** Input field Code Start */}

            {/** Rom Poc Code Start */}
            <div
              className="tab-pane fade"
              id="addProject"
              role="tabpanel"
              aria-labelledby="addProject-tab"
            >
              <div className="mt-2 mb-3">
                <div className="p-2">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="table-responsive poc-head rounded">
                        <button
                          type="button"
                          onClick={handleAddLine}
                          className="custom-btn-sm mb-1 pull-right"
                        >
                          <i class="fa fa-plus"></i>&nbsp;Add
                        </button>
                        <Table
                          style={{ background: "#ECECEC !important" }}
                          // id="poctable_head"
                          className="table table-bordered"
                        >
                          <thead id="thcolor" className="text-center ">
                            <tr>
                              <th>Sr. No.</th>
                              <th>
                                Name<span className="text-danger">*</span>
                              </th>
                              <th>Designation</th>
                              <th>Department</th>
                              <th>
                                Contact No.
                                <span className="text-danger ms-2">
                                  *
                                </span>
                              </th>
                              <th>
                                Email ID<span className="text-danger">*</span>
                              </th>
                              <th>Remarks</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {formData1.lines.map((line, index) => (
                              <tr key={index} className="">
                                <td className="px-0 text-center align-middle">
                                  {index + 1}
                                </td>
                                <td className="px-0">
                                  <input
                                    type="text"
                                    name="RefName"
                                    className={`form-control mx-auto ${errors[index]?.RefName
                                      ? "is-invalid"
                                      : ""
                                      }`} // Accessing errors for the specific line
                                    value={line.RefName}
                                    onChange={(e) => handleChange(e, index)}
                                    style={{ width: "150px" }} // Set the width here
                                  />

                                  {errors[index]?.RefName && ( // Accessing errors for the specific line
                                    <div className="invalid-feedback text-center">
                                      {errors[index].RefName}{" "}
                                      {/* Displaying the error message */}
                                    </div>
                                  )}
                                </td>
                                <td className="px-0">
                                  <input
                                    type="text"
                                    name="RefDesignation"
                                    className={`form-control mx-auto`}
                                    value={line.RefDesignation}
                                    onChange={(e) => handleChange(e, index)}
                                    style={{ width: "150px" }} // Set the width here
                                  />
                                </td>
                                <td className="px-0">
                                  <input
                                    type="text"
                                    name="RefDepartment"
                                    className={`form-control mx-auto`}
                                    value={line.RefDepartment}
                                    onChange={(e) => handleChange(e, index)}
                                    style={{ width: "150px" }} // Set the width here
                                  />
                                </td>
                                <td className="px-0">
                                  <input
                                    type="number"
                                    name="RefContact"
                                    value={line.RefContact}
                                    className={`form-control mx-auto ${errors[index]?.RefContact
                                      ? "is-invalid"
                                      : ""
                                      }`}
                                    onChange={(e) => handleChange(e, index)}
                                    style={{ width: "150px" }} // Set the width here
                                  />{" "}
                                  {errors[index]?.RefContact && ( // Accessing errors for the specific line
                                    <div className="invalid-feedback text-center">
                                      {errors[index].RefContact}{" "}
                                      {/* Displaying the error message */}
                                    </div>
                                  )}
                                </td>
                                <td className="px-0">
                                  <input
                                    type="email"
                                    name="RefEmail"
                                    value={line.RefEmail}
                                    className={`form-control mx-auto ${errors[index]?.RefEmail
                                      ? "is-invalid"
                                      : ""
                                      }`} // Accessing errors for the specific line
                                    onChange={(e) => handleChange(e, index)}
                                    style={{ width: "150px" }} // Set the width here
                                  />
                                  {errors[index]?.RefEmail && ( // Accessing errors for the specific line
                                    <div className="invalid-feedback text-center">
                                      {errors[index].RefEmail}{" "}
                                      {/* Displaying the error message */}
                                    </div>
                                  )}
                                </td>
                                <td className="px-0">
                                  <input
                                    type="text"
                                    name="RefRemarks"
                                    value={line.RefRemarks}
                                    className={`form-control mx-auto`}
                                    onChange={(e) => handleChange(e, index)}
                                    style={{ width: "150px" }} // Set the width here
                                  />
                                </td>
                                <td className="text-center align-middle">
                           <div
  type="button"
    style={{
      cursor: line?.ID ? "not-allowed" : "pointer",
     
    }}
  onClick={() =>
  line?.ID?"":  openDeleteModal({ index, vendorID: line.vendorID, LineNo: line.LineNo })
  }
>
  <i
    className={`bi bi-trash icons ${line?.ID ? "disabled-icon" : ""}`}
    style={{
      cursor: line?.ID ? "not-allowed" : "pointer",
      color: "#000",
      fontSize: "1.2rem",
    }}
  ></i>
</div>

                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/** Rom Poc Code End */}

          {/** Button Code start */}

          <div className="pb-2 pe-2">
            <div className="text-end">
              <button
                type="button"
                className="cancel-btn me-2"
                onClick={() => {
                  navigate("/partner-master");
                }}
              >
                Cancel
              </button>
              <button
                disabled={loading ? true : false}
                type="submit"
                className="custom-btn"
              >
                {loading ? <FaSpinner class="sm-spinner" /> : "Submit"}
              </button>
            </div>
          </div>
          {/** Button Code end */}
        </form>

        <DeleteModal
          show={showDeleteModal}
          onClose={handleDeleteClose}
          onConfirm={handleModalDelete}
          message="Are you sure you want to delete this item?"
        />
      </div >

    </>
  );
};

export default CreatePartnerMasterEdit;
